import React, { useState, useMemo } from 'react';

import moment from 'moment';

import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  Input,
  RadioGroup,
  Select,
} from '~/components/Form';

import * as Yup from 'yup';

import { t, parseDateString } from '~/helpers';

import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';

function Relvazaonaoautorizada() {
  const [open, setOpen] = useState(true);
  const [posto, setPosto] = useState(0);
  const [produto, setProduto] = useState(0);
  const [bico, setBico] = useState(0);

  //NOVOS CAMPOS
  const [valueOrgao, setValueOrgao] = React.useState(0);
  const [inputValueOrgao, setInputValueOrgao] = React.useState('');

  const [valueUnidade, setValueUnidade] = React.useState(0);
  const [inputValueUnidade, setInputValueUnidade] = React.useState('');

  const [valuePosto, setValuePosto] = React.useState(0);
  const [inputValuePosto, setInputValuePosto] = React.useState('');

  const [valueBico, setValueBico] = React.useState(0);
  const [inputValueBico, setInputValueBico] = React.useState('');

  const [valueProduto, setValueProduto] = React.useState(0);
  const [inputValueProduto, setInputValueProduto] = React.useState('');

  const listaAgrupamentos = [
    { value: '1', label: 'Listagem' },
    { value: '2', label: 'Posto' },
    { value: '3', label: 'Bico' },
    { value: '4', label: 'Produto' },
    { value: '5', label: 'Data' },
  ];

  // const start = moment()
  //   .subtract({ day: 7 })
  //   .set({ hour: 0, minute: 0, second: 0 });

  // const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );


  async function handleValidate(param) {
    try {
      const schema = Yup.object().shape({
        datahorainicial: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio')),
        datahorafinal: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(
            datahorafinal,
            `A data não pode ser superior a ${datahorafinal}`
          )
          .min(
            Yup.ref('datahorainicial'),
            'A data não pode ser inferior a Data inicial'
          ),
      });

      await schema.validate(param, {
        abortEarly: false,
      });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }

  function handleSerializeForm(params) {
    const { datahorainicial, datahorafinal } = params;

    let posto = '';
    if (params.poco_codigo) {
      posto = params.poco_codigo;
    } else {
      posto = '';
    }

    let postostr = '';
    if (params.poco_desc_abrev) {
      postostr = params.poco_desc_abrev;
    } else {
      postostr = '';
    }

    let bico = valueBico > 0 ? valueBico : '';

    // let bico = '';
    // if (params.bico_numero) {
    //   bico = params.bico_numero;
    // } else {
    //   bico = '';
    // }

    let bicostr = inputValueBico;

    // let bicostr = '';
    // if (params.bico_descricao) {
    //   bicostr = params.bico_descricao;
    // } else {
    //   bicostr = '';
    // }

    let produto = '';
    if (params.prod_codigo) {
      produto = params.prod_codigo;
    } else {
      produto = '';
    }

    let produtostr = '';
    if (params.prod_descricao) {
      produtostr = params.prod_descricao;
    } else {
      produtostr = '';
    }

    let agrupamento = '';
    if (params.abastecimentoagrupamento) {
      agrupamento = params.abastecimentoagrupamento;
    } else {
      agrupamento = '1';
    }

    let agrupamentostr = listaAgrupamentos[Number(agrupamento) - 1].label;

    let tipo = 'pdf';
    if (params.formato) {
      tipo = params.formato;
    } else {
      tipo = 'pdf';
    }

    return {
      ...params,
      posto,
      postostr,
      bico,
      bicostr,
      produto,
      produtostr,
      agrupamento,
      agrupamentostr,
      tipo,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title="Vazão não autorizada"
      relatorio="VAZAMENTOS"
      serialize={(param) => handleSerializeForm(param)}

      validate={(param) => handleValidate(param)}

      initials={{
        datahorainicial,
        datahorafinal,
        // datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        // datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
        
      }}
    >
      {/* <DateTime
        label="Data Inicial"
        name="datahorainicial"
        serialize={(value) =>
          value.set({ second: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time        
      />

      <DateTime
        label="Data Final"
        name="datahorafinal"
        serialize={(value) =>
          value.set({ second: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time        
      /> */}

      <DateTime
        time
        label="Data Inicial"
        name="datahorainicial"
        disableFuture={true}
      />

      <DateTime
        time
        label="Data Final"
        name="datahorafinal"
        disableFuture={true}
        invalidDateMessage={''}
        minDateMessage={''}
        maxDateMessage={''}
      />

      <Autocomplete
        name="poco_codigo"
        label="poco_desc_abrev"
        title="Posto"
        id="poco_codigo"
        url="postoscomboios"
        unique="poco_codigo"
        value={valuePosto}
        inputValue={inputValuePosto}
        onChange={(event, newValue) => {
          setValueBico(0);
          setInputValuePosto('');
          setValuePosto(newValue);
        }}
        onInputChange={(event, newInputValuePosto) => {
          setInputValuePosto(newInputValuePosto);
        }}
        defaultValue=""
        hiddens={[{ name: 'poco_desc_abrev' }]}
        getValue={(value) => {
          setValueBico(0);
          setInputValueBico('');
          if (value.poco_codigo !== null) {
            setValuePosto(value.poco_codigo);
          } else {
            setValuePosto(0);
          }
        }}
      />

      <Autocomplete
        name="bico_numero"
        label="bico_descricao"
        title="Bico"
        id="bico_numero"
        url="bicos"
        unique="bico_numero"
        value={valueBico}
        inputValue={inputValueBico}
        onChange={(event, newValue) => {
          setValueBico(newValue);
        }}
        onInputChange={(event, newInputValueBico) => {
          setInputValueBico(newInputValueBico);
        }}
        defaultValue=""
        hiddens={[{ name: 'bico_descricao' }]}
        getValue={(value) => {
          if (value.bico_numero !== null) {
            setValueBico(value.bico_numero);
          } else {
            setValueBico(0);
          }
        }}
        params={{
          wherefield: 'poco_codigo',
          valuewherefield: valuePosto,
          typewherefield: 'EQUALS',
        }}
      />

      <Autocomplete
        name="prod_codigo"
        label="prod_descricao"
        title="Produto"
        id="prod_codigo"
        url="produtos"
        unique="prod_codigo"
        value={valueProduto}
        inputValue={inputValueProduto}
        onChange={(event, newValue) => {
          setValueProduto(newValue);
        }}
        onInputChange={(event, newInputValueProtudo) => {
          setInputValueProduto(newInputValueProtudo);
        }}
        defaultValue=""
        hiddens={[{ name: 'prod_descricao' }]}
        getValue={(value) => {
          if (value.prod_codigo !== null) {
            setValueProduto(value.prod_codigo);
          } else {
            setValueProduto(0);
          }
        }}
      />

      <Select
        name="abastecimentoagrupamento"
        variant="outlined"
        size="small"
        label="Agrupamento"
        defaultValue="1"
        options={listaAgrupamentos}
      />

      <RadioGroup
        name="formato"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relvazaonaoautorizada;
